"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.refreshTeacherHasConfirmedUploadWarning = exports.refreshInRestrictedShareMode = exports.unsetNameFailure = exports.setNameFailure = exports.setShowTryAgainDialog = exports.refreshProjectName = exports.setProjectUpdatedAt = exports.setProjectUpdatedSaved = exports.setProjectUpdatedSaving = exports.closeWorkspaceAlert = exports.displayWorkspaceAlert = exports.setProjectUpdatedError = exports.showProjectUpdatedAt = exports.workspaceAlertTypes = exports.projectUpdatedStatuses = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
exports.projectUpdatedStatuses = {
    default: 'default',
    saving: 'saving',
    saved: 'saved',
    error: 'error',
};
exports.workspaceAlertTypes = {
    error: 'error',
    warning: 'warning',
    notification: 'notification',
};
var initialState = {
    showProjectUpdatedAt: false,
    projectUpdatedStatus: exports.projectUpdatedStatuses.default,
    projectUpdatedAt: undefined,
    // This is the legacy project name. The lab2 project
    // name is part of lab2Redux, in the channel.
    projectName: '',
    projectNameFailure: undefined,
    showTryAgainDialog: false,
    workspaceAlert: null,
    inRestrictedShareMode: false,
    teacherHasConfirmedUploadWarning: false,
};
var projectReduxSlice = (0, toolkit_1.createSlice)({
    name: 'project',
    initialState: initialState,
    reducers: {
        showProjectUpdatedAt: function (state) {
            state.showProjectUpdatedAt = true;
        },
        setProjectUpdatedError: function (state) {
            state.projectUpdatedStatus = exports.projectUpdatedStatuses.error;
        },
        displayWorkspaceAlert: {
            reducer: function (state, action) {
                state.workspaceAlert = action.payload;
            },
            prepare: function (type, message, displayBottom) {
                return { payload: { type: type, message: message, displayBottom: displayBottom } };
            },
        },
        closeWorkspaceAlert: function (state) {
            state.workspaceAlert = null;
        },
        setProjectUpdatedSaving: function (state) {
            state.projectUpdatedStatus = exports.projectUpdatedStatuses.saving;
        },
        setProjectUpdatedSaved: function (state) {
            state.projectUpdatedStatus = exports.projectUpdatedStatuses.saved;
        },
        setProjectUpdatedAt: function (state, action) {
            state.projectUpdatedAt = action.payload;
            state.projectUpdatedStatus = exports.projectUpdatedStatuses.saved;
        },
        refreshProjectName: function (state) {
            state.projectName = dashboard.project.getCurrentName();
        },
        setShowTryAgainDialog: function (state, action) {
            state.showTryAgainDialog = action.payload;
        },
        setNameFailure: function (state, action) {
            state.projectNameFailure = action.payload;
        },
        unsetNameFailure: function (state) {
            state.projectNameFailure = undefined;
        },
        refreshInRestrictedShareMode: function (state) {
            state.inRestrictedShareMode = dashboard.project.inRestrictedShareMode();
        },
        refreshTeacherHasConfirmedUploadWarning: function (state) {
            state.teacherHasConfirmedUploadWarning =
                dashboard.project.teacherHasConfirmedUploadWarning();
        },
    },
});
exports.showProjectUpdatedAt = (_a = projectReduxSlice.actions, _a.showProjectUpdatedAt), exports.setProjectUpdatedError = _a.setProjectUpdatedError, exports.displayWorkspaceAlert = _a.displayWorkspaceAlert, exports.closeWorkspaceAlert = _a.closeWorkspaceAlert, exports.setProjectUpdatedSaving = _a.setProjectUpdatedSaving, exports.setProjectUpdatedSaved = _a.setProjectUpdatedSaved, exports.setProjectUpdatedAt = _a.setProjectUpdatedAt, exports.refreshProjectName = _a.refreshProjectName, exports.setShowTryAgainDialog = _a.setShowTryAgainDialog, exports.setNameFailure = _a.setNameFailure, exports.unsetNameFailure = _a.unsetNameFailure, exports.refreshInRestrictedShareMode = _a.refreshInRestrictedShareMode, exports.refreshTeacherHasConfirmedUploadWarning = _a.refreshTeacherHasConfirmedUploadWarning;
exports.default = projectReduxSlice.reducer;
